import {Component} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {RouterLink} from '@angular/router';
import {AuthenticationService} from '@authentication/authentication.service';

@Component({
  selector: 'app-logout',
  imports: [MatButtonModule, RouterLink],
  templateUrl: './logout.component.html',
})
export class LogoutComponent {
  constructor(authService: AuthenticationService) {
    if (authService.token()) {
      authService.beginLogout();
    }
  }
}
